/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowUpFromArc = createReactComponent("arrow-up-from-arc", "IconArrowUpFromArc", [
  ["path", { d: "M12 9v12", key: "svg-0" }],
  ["path", { d: "M8 17l4 4l4 -4", key: "svg-1" }],
  ["path", { d: "M21 12a9 9 0 0 0 -18 0", key: "svg-2" }]
]);

export { IconArrowUpFromArc as default };
//# sourceMappingURL=IconArrowUpFromArc.js.map
